<template>
  <div class="app-change-tariff-wrapper">
    <ChangeTariffInput :extra="extra" v-if="showInput">
      <template #txtBookedTariff>
        <slot name="txtBookedTariffChangeTariff"></slot>
      </template>
      <template #txtBeforeBookableTariffs>
        <slot name="txtBeforeBookableTariffsChangeTariff"></slot>
      </template>
      <template #txtAfterBookableTariffs>
        <slot name="txtAfterBookableTariffsChangeTariff"></slot>
      </template>
      <template #txtBookableTariffsElse>
        <slot name="txtBookableTariffsElseChangeTariff"></slot>
      </template>
      <template #btnNext>
        <slot name="btnNextChangeTariff"></slot>
      </template>
    </ChangeTariffInput>
    <ChangeTariffSummary v-if="showSummary">
      <template #txtSummary>
        <slot name="txtSummaryChangeTariff"></slot>
      </template>
      <template #btnPrevSummary>
        <slot name="btnPrevSummaryChangeTariff"></slot>
      </template>
      <template #btnNextSummary>
        <slot name="btnNextSummaryChangeTariff"></slot>
      </template>
    </ChangeTariffSummary>
    <ChangeTariffSuccess v-if="showSuccess">
      <template #txtSuccess>
        <slot name="txtSuccessChangeTariff"></slot>
      </template>
      <template #btnPrev>
        <slot name="btnPrevChangeTariff"></slot>
      </template>
    </ChangeTariffSuccess>
  </div>
</template>
<script>
import ChangeTariffInput, { stepName as inputStepName } from './Input.vue'
import ChangeTariffSuccess, { stepName as successStepName } from './Success.vue'
import ChangeTariffSummary, { stepName as summaryStepName } from './Summary.vue'
import { mapGetters } from 'vuex'
import transaction from '@/mixins/transaction'

export default {
  name: 'ChangeTariffWrapper',
  components: {
    ChangeTariffInput,
    ChangeTariffSuccess,
    ChangeTariffSummary
  },
  mixins: [
    transaction('changeTariff')
  ],
  props: {
    extra: {
      type: String
    }
  },
  computed: {
    showInput () {
      return this.currentStep === inputStepName
    },
    showSuccess () {
      return this.currentStep === successStepName
    },
    showSummary () {
      return this.currentStep === summaryStepName
    },
    ...mapGetters('changeTariff', [
      'currentStep'
    ])
  }
}
</script>
